<div class="substance-binds-to-target-container" [formGroup]="currentForm">
  <div id="substance-binds-to-target-text" class="substance-binds-to-target-text" [ngClass]="{ 'substance-binds-to-target-text__full' : !isMobileDeviceSize }">
    Does the substance bind to a receptor, enzyme, or other target?
  </div>
  <div class="radio-input-row">
    <input type="radio" aria-label="Yes" [id]="'doesBind'" [value]="'Yes'" name="bindsToTargetSelected" formControlName="substanceBindsToTarget" (change)="updateBindsValue('Yes')" [checked]="compareFn('Yes')">
    <label [for]="'doesBind'">Yes</label>
    <input type="radio" aria-label="No" [id]="'doesntBind'" [value]="'No'" name="bindsToTargetSelected" formControlName="substanceBindsToTarget" (change)="updateBindsValue('No')" [checked]="compareFn('No')">
    <label [for]="'doesntBind'">No</label>
  </div>
  <div class="input-error" *ngIf="hasFieldValidationError('substanceBindsToTarget')">
      This is a required field.
  </div>
</div>